import dayjs from "dayjs";
import dayjsTZ from "../../../utils/dayjs";

const CLOCKIN_TYPES_FIELD_NAME = "ClockIn Types";

const normalize = (str) =>
  `${str || ""}`
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toLowerCase();

const isAbsenceOption = (option) =>
  normalize(option?.description).startsWith("mungese") ||
  normalize(option?.name).startsWith("mungese");

//"Mungesë me arsye" keeps its start and end: the employee was available but could not
//work (e.g. a power outage from 14:00 to 16:00), so only that slice of the day is absence
const isTimedAbsenceOption = (option) =>
  [option?.description, option?.name].some((str) =>
    normalize(str).replace(/[^a-z]/g, "").startsWith("mungesemearsye")
  );

const getClockInTypes = (programFields) =>
  (programFields || []).find(
    (el) => el?.fieldName === CLOCKIN_TYPES_FIELD_NAME
  )?.fieldOptions || [];

//absences without punch times (e.g. "Mungesë pa arsye"): the shift collapses onto its day
export const getAbsenceDayTypes = (programFields) =>
  getClockInTypes(programFields)
    .filter((el) => isAbsenceOption(el) && !isTimedAbsenceOption(el))
    .map((el) => el?.name);

export const getTimedAbsenceDayTypes = (programFields) =>
  getClockInTypes(programFields)
    .filter(isTimedAbsenceOption)
    .map((el) => el?.name);

export const getAbsencePunch = (date) =>
  (dayjs.isDayjs(date) ? date : dayjsTZ(date))
    .set("hour", 12)
    .set("minute", 0)
    .set("second", 0)
    .set("millisecond", 0)
    .valueOf();

export const hasNoPunchTimes = (shift) =>
  !!shift?.clockInDate &&
  !!shift?.clockOutDate &&
  dayjsTZ(shift.clockInDate).valueOf() ===
    dayjsTZ(shift.clockOutDate).valueOf();
